module.exports = __webpack_public_path__ + "static/media/HBD_black.6bd08998.gif";